import React from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  useTheme,
  useMediaQuery
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons";
import CloseIcon from "@mui/icons-material/Close";
import Terms from "../parts/terms";

const HomeFooter = () => {
  const [showTerms, setShowTerms] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const openTerms = () => setShowTerms(true);
  const closeTerms = () => setShowTerms(false);

  return (
    <>
      <Dialog open={showTerms} onClose={closeTerms} maxWidth="md" fullWidth fullScreen={isMobile}>
        <DialogTitle>
          Terms of Service
          <IconButton
            onClick={closeTerms}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Terms />
        </DialogContent>
      </Dialog>
      <Box
        component="footer"
        sx={{
          backgroundColor: '#f8f9fa',
          padding: '1rem 0',
          marginTop: 'auto',
          borderTop: '1px solid #e9ecef',
          position: 'sticky',
          bottom: 0,
          zIndex: 1
        }}
      >
        <Grid container maxWidth="lg" sx={{ margin: '0 auto', padding: '0 1rem', alignItems: 'center' }}>
          <Grid item xs={12} md={8}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#495057', fontSize: '1rem' }}>
                ShieldShot LLC
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: '#6c757d', fontSize: '0.875rem', cursor: 'pointer', ml: 2 }}
                onClick={openTerms}
              >
                Terms of Service
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: '#6c757d', fontSize: '0.875rem', cursor: 'pointer', ml: 2 }}
                onClick={() => window.location.href = '/feedback'}
              >
                Feedback
              </Typography>
              <Typography
                variant="body2"
                sx={{ color: '#6c757d', fontSize: '0.875rem', cursor: 'pointer', ml: 2 }}
                onClick={() => window.location.href = '/faq'}
              >
                FAQ
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'right', md: 'right' }, mt: { xs: 1, md: 0 } }}>
            <Box sx={{ mb: 1 }}>
              <IconButton
                component="a"
                href="https://www.facebook.com/shieldshot.llc/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#1877f2', mr: 1, p: '4px' }}
                size="small"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </IconButton>
              <IconButton
                component="a"
                href="https://twitter.com/shieldshot_llc"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: '#1da1f2', p: '4px' }}
                size="small"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </IconButton>
            </Box>
          </Grid>
          <Grid item xs={12} sx={{ mt: 1, pt: 1, borderTop: '1px solid #dee2e6' }}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.75rem' }}>
                  3101 N. Central Avenue Suite 183 #357 Phoenix, Arizona 85012
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'right' }, mt: { xs: 0.5, md: 0 } }}>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.75rem' }}>
                  © Copyright all rights reserved
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default HomeFooter;
